import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of, Subscriber } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { AppyUser } from '../../core/model/v2/AppyUser';
import { MapLocation } from '../../core/models/google-map-marker';
import { Patient } from '../../core/models/patient/patient';
import { PatientFavoriteRequest } from '../../core/models/patient/patientFavoriteRequest';
import { CommonService } from '../../core/services/v2/common.service';
import { GeoLocationService } from '../../core/services/v2/geolocation.service';
import { PatientService } from '../../core/services/v2/patient.service';
import { PracticeService } from '../../core/services/v2/practice.service';
import { UserService } from '../../core/services/v2/user.service';
import { UtilsService } from '../../core/services/v2/utils.service';
import { PractitionersService } from '../../practitioners/practitioners.service';
import { WindowLoaderService } from '../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-patient-favorites',
  templateUrl: './patient-favorites.component.html',
  styleUrls: ['./patient-favorites.component.scss']
})
export class PatientFavoritesComponent implements OnInit {
  @Input() patientDetails: Patient;
  user: AppyUser;
  patientFavoritePractitioners: any;
  isParams = false;
  param: number;
  searchProvider: FormControl = new FormControl('');
  providerFilteredOptions: Observable<any[]>;
  currentLocation: MapLocation;
  patientZipCode: string;
  planid: string;
  planName: string;
  constructor(
    private patientService: PatientService,
    private commonService: CommonService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: WindowLoaderService,
    private locationService: GeoLocationService,
    private utils: UtilsService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(
      (params: any) => {
        if (params.id) {
          this.isParams = true;
          this.param = params.id;
        }
      },
      (error) => { console.error(error); }
    );
    
    this.loadLocationAndUserDetails();

    this.providerFilteredOptions = this.searchProvider.valueChanges.pipe(
      startWith(''),
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((val) => {
        if (!val || val.length < 3) {
          return new Observable<any[]>();
        }
        return this._filter(val || '');
      })
    );

  }

  private SetPhyCardParams() {
    
        let patientZip = this.patientDetails.addresses.find(x => x.type == 'HOME');
        if (!patientZip) {
            patientZip = this.patientDetails.addresses.find(x => x.zipCode != null);
        }
        this.patientZipCode = patientZip.zipCode ? patientZip.zipCode : "";

    const insuranceDetail = this.patientDetails.patientInsurances.find(x => x.insuranceType == "Primary" && x.insurancePlanPayerId != null);
        if (insuranceDetail) {
          this.planid = insuranceDetail.insurancePlanPayerId ? insuranceDetail.insurancePlanPayerId.toString() : "";
            this.planName = insuranceDetail.insurancePlanName ? insuranceDetail.insurancePlanName : "";
    }
    }

  loadLocationAndUserDetails() {
    this.locationService.getPosition().then((pos) => {
      //this.currentLocation = { lat: pos.lat, lng: pos.long };
      this.currentLocation = { lat: 25.828855, lng: -80.316183 };
      this.userService.getUserDetails().subscribe(
        (res) => {
          this.user = res;
          
          if (this.patientDetails == undefined) {
            this.loaderService.blockWithLoader(this.patientService.getCurrentPatientDetails()).subscribe(
              (details) => {
                this.patientDetails = null;
                this.patientDetails = details;
                this.getPatientFavoritesById(this.user.patientId);
                this.SetPhyCardParams();
              },
              (error) => { console.error(error); }
            );
          }
          else {
            this.SetPhyCardParams();
          }
        },
        (error) => { console.error(error); });
    }).catch((err) => {
      alert('Please enable location and refresh again to get accurate data while searching.');
      this.userService.getUserDetails().subscribe(
        (res) => {
          this.user = res;
          this.getPatientFavoritesById(this.user.patientId);
        },
        (error) => { console.error(error); });
    });


  }

  //getPatientDetailsById(id) {
  //  //id = 35178;
  //  this.loaderService.blockWithLoader(this.patientService.getPatientDetailsById(id)).subscribe(
  //    (details) => {
  //      this.patientProfile = null;
  //      this.patientProfile = details;
  //      //this.patientProfile.photoUrl = this.patientProfile.photoUrl += '?' + Math.random();
  //      this.getPatientFavoritesById(this.patientProfile.id);
  //    },
  //    (error) => { console.error(error); }
  //  );
  //}

  //getPatientDetailsByUserId() {
  //  this.loaderService.blockWithLoader(this.patientService.getCurrentPatientDetails()).subscribe(
  //    (details) => {
  //      this.patientProfile = null;
  //      this.patientProfile = details;
  //      //this.patientProfile.photoUrl = this.patientProfile.photoUrl += '?' + Math.random();
  //      this.getPatientFavoritesById(this.patientProfile.id);
  //    },
  //    (error) => { console.error(error); }
  //  );
  //}

  getPatientFavoritesById(id) {
    this.loaderService.blockWithLoader(this.patientService.getPatientFavoritesById(id)).subscribe(
      (details) => {
        this.patientFavoritePractitioners = details.practitioners;
        if (this.patientFavoritePractitioners && this.currentLocation) {
          for (let i = 0; i < this.patientFavoritePractitioners.length; i++) {
            if (this.patientFavoritePractitioners[i].locations && this.patientFavoritePractitioners[i].locations.length > 0) {
              this.patientFavoritePractitioners[i].distance = this.utils.calculateGeoDistance(this.patientFavoritePractitioners[i].locations[0].latitude, this.patientFavoritePractitioners[i].locations[0].longitude, this.currentLocation.lat, this.currentLocation.lng, true).toFixed(1);
            }
          }
        }
      },
      (error) => { console.error(error); }
    );
  }

  private _filter(value: string): Observable<any[]> {
    const filterValue = value.toLowerCase();
    if (this.patientFavoritePractitioners) {
      let data = this.patientFavoritePractitioners.filter(option => option.fullName.toLowerCase().includes(filterValue));
      if (data && data.length > 0) {
        return of(data);
      }
    }

    //const apiUrl = 'Practitioner/GetPractitionersByName?searchText=' + value;
    //return this.commonService.getDynamicSearchApiData(apiUrl).pipe(
    //  tap(),
    //  map((response) => {
    //    return response.practitioners;
    //  })
    //);

    const searchParams = {
      "searchTerm": value,
      "latitude": this.currentLocation.lat ? this.currentLocation.lat : 0,
      "longitude": this.currentLocation.lng ? this.currentLocation.lng : 0,
      //"zipCode": '',
      //"userId": 0
    };
    return this.loaderService.blockWithLoader(this.commonService.SearchForProvidersByGivenCriteria(searchParams)).pipe(
      tap(),
      map((response) => {
        return response;
      })
    );
  }

  openPractitionerProfile(practitionerData: any) {
    this.searchProvider.setValue(practitionerData.fullName);

    if (practitionerData.searchType == 'Physician' || practitionerData.searchType == 'Medical Professional' || practitionerData.npitype == "PRACTITIONER") {
      let dataToPass: any = {
        src: "summary",
        patientId: this.user.patientId
      };
      if (practitionerData.isInNetwork && practitionerData.searchId && practitionerData.searchId > 0) {
        dataToPass.id = practitionerData.searchId;
      }
      else if (practitionerData.npiNumber || practitionerData.npi) {
        dataToPass.npi = practitionerData.npiNumber ? practitionerData.npiNumber : practitionerData.npi;
      }
      this.router.navigate([
        "/patient/physician/profile",
        dataToPass
      ]);
    }
    else if (practitionerData.searchType == 'HealthSystem') {
      if (practitionerData.searchId) {
        this.router.navigate([`/practice/profile/profilelocation/${practitionerData.searchId}`]);
      }
      else {
        this.utils.showMessageSnackBar('Health System is out of network.', true);
      }
    }
  }

  removePatientFavorite(practitionerData: any) {
    Swal.fire({
      title: `Remove Favorite`,
      text: `Are you sure want to remove Dr. ${practitionerData.fullName} from your favorite?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Remove!'
    }).then((result) => {
      if (result.isConfirmed) {
        let data: PatientFavoriteRequest = {
          userId: this.user.id,
          patientId: this.user.patientId,
          favoriteNPIId: practitionerData.npi,
          npiType: practitionerData.npitype,
          action: 'REMOVE'
        }
        this.loaderService.blockWithLoader(this.patientService.setOrRemovePatientFavorites(data)).subscribe(
          (details) => {
            this.getPatientFavoritesById(this.user.patientId);
            Swal.fire(
              'Removed!',
              'Practitioner is removed from your favorite list.',
              'success'
            )
          },
          (error) => { console.error(error); }
        );
      }
    })

  }

}
